import { Component, EventListener } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import { dispatchCustomEvent, EventNames } from '@swisslife/shared-ui/src/utils/custom-event/js/custom-event';
import addComponentAnimation from '@swisslife/shared-ui/src/utils/animations/js/animations';

enum Selectors {
	Shariff = '.js-m-share__shariff',
	ShariffButton = '.shariff-button',
}

// The @Component decorator will connect the class with `data-g-name="Share"` elements.
@Component('Share')
export class Share extends GondelJqueryComponent {
	private controllers: any[] = Array();

	public async sync() {
		await this.initializeSocialShariff();
		this.controllers = await addComponentAnimation(this.$ctx);
	}

	public stop() {
		for (const controller of this.controllers) {
			controller.destroy(true);
		}
	}

	@EventListener('click', Selectors.ShariffButton)
	public _handleShareEvent(event) {
		const channel = event.target.parentElement.classList[1] || 'unknown channel';
		dispatchCustomEvent(this.$ctx, EventNames.SocialShare, { channel });
	}

	/**
	 * Dynamically load Shariff plugin
	 */
	private async initializeSocialShariff() {
		await import(/* webpackChunkName: "dynamic-imports/share-lib" */ './share-lib');

		// needed to work after being rendered via ajax
		// see https://github.com/heiseonline/shariff/issues/164#issuecomment-220956785
		// cannot use constructor based init because it does not work in IE11
		this.$ctx.find(Selectors.Shariff).each(function() {
			if (!this.hasOwnProperty('shariff')) {
				(this as any).shariff = new (window as any).Shariff(this);
			}
		});
	}
}
